export function setAvailableGames(availableGames) {
    return { type: "AVAILABLE_GAMES", availableGames: availableGames };
}